export interface AnnotationAttachment {
  url?: string;
  path?: string;
  preview?: string;
  [key: string]: any;
}

export const displaySource = (
  image: AnnotationAttachment | undefined,
  annotatedUrl: string | undefined
): string | undefined => {
  const localPreview: string | undefined = image?.preview;
  const uploadedUrl: string | undefined = image?.url;

  return annotatedUrl ?? localPreview ?? uploadedUrl;
};

export const imageName = (image: AnnotationAttachment | undefined): string => {
  const fileName: string | undefined = image?.name;
  const droppedPath: string | undefined = image?.path;

  return fileName ?? droppedPath ?? 'Attachment';
};

export const attachmentKey = (image: AnnotationAttachment | undefined): string => {
  if (!image) {
    return '';
  }

  const objectUrl: string | undefined = image.preview;
  const uploadedUrl: string | undefined = image.url;
  const fileName: string | undefined = image.path;

  return objectUrl ?? uploadedUrl ?? fileName ?? '';
};